import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { handleSubmitDocumentEditSubmit } from 'components/views/FounderVault/_helpers/founderVault.events';
import { $form, $view } from 'signals/global.signals';
import getSelectValue from 'utils/getSelectValue';

const FounderDocumentsEditModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-document-edit'}
    isLoading={$view.value?.isModalLoading}
    title={`Edit Document - ${$view.value.fileName}`}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitDocumentEditSubmit}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <UniversalInput
      label="File Name"
      name="name"
      type="text"
      placeholder="Enter name"
      className="mb-16"
    />

    <UniversalInput
      label="Folder"
      name="folder"
      type="select"
      options={$view.value?.folderOptions || []}
      value={getSelectValue($form.value.folder) || null}
      className="mb-16"
      isCreatable
      customOnChange={(selectedOption) => {
        $form.update({
          folder: selectedOption,
        });
      }}
    />
  </SimpleModal>
);

export default FounderDocumentsEditModal;
